import { Card, CardBody, CardHeader, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { changeTracaoManifesto, changeTracaoProp, clearError, clearTracaoProp } from "../../../features/manifestoSlice";
import { handleNumberOnly } from "../../../utils/utils";
import { RootState } from "../../../app/store";
import { MakeMessageError } from "../../../components/Components";
import { useState } from "react";
import Condutores from "./Condutores";
import { TypeCarroceriaVeiculo, TypeProprietarioVeiculo, TypeRodadoVeiculo } from "../../../lists";

export default function Veiculo() {
    const selectEstados = useSelector((state: RootState) => state.manifesto.selectEstados);
    const form = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario?.tracao);
    const formProp = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario?.tracao.prop);
    const errors = useSelector((state: RootState) => state.manifesto.listaErrors);
    const [showProp, setShowProp] = useState<boolean>(false);
    const dispatch = useDispatch();

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeTracaoManifesto({ [name]: value }));
        dispatch(clearError('modal_rodoviario_tracao_' + name))
    }

    const handleChangeShowProp = (e: any) => {
        setShowProp(e.target.checked)
        if (!e.target.checked) {
            dispatch(clearTracaoProp());
        }
    }

    const handleChangeProp = (e: any) => {
        const { name, value } = e.target;
        dispatch(changeTracaoProp({ [name]: value }));
        dispatch(clearError('modal_rodoviario_tracao_prop_' + name))
    }

    return (<Row className="g-2 mb-2">
        <Col md={5}>
            <Condutores />
        </Col>
        <Col >
            <Card>
                <CardHeader className="fw-bold">
                    Dados do Veículo
                </CardHeader>
                <CardBody className="p-2">
                    <Row className="g-2 mb-3">

                        <Col md={2}>
                            <Form.Group controlId="placa">
                                <Form.Label>* Placa</Form.Label>
                                <Form.Control name="placa" value={form.placa} type="text"
                                    className={`${errors.modal_rodoviario_tracao_placa?.length > 0 ? "is-invalid" : ""}`}
                                    onChange={handleChange} maxLength={7} />
                                <MakeMessageError errors={errors} field="modal_rodoviario_tracao_placa" />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group controlId="tara">
                                <Form.Label>* Tara(kg)</Form.Label>
                                <Form.Control name="tara" type="text" value={form.tara}
                                    className={`${errors.modal_rodoviario_tracao_tara?.length > 0 ? "is-invalid" : ""}`}
                                    onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={6} />
                                <MakeMessageError errors={errors} field="modal_rodoviario_tracao_tara" />
                            </Form.Group>
                        </Col>

                        <Col md={3}>
                            <Form.Group controlId="RENAVAM">
                                <Form.Label>RENAVAM</Form.Label>
                                <Form.Control name="RENAVAM" type="text"
                                    value={form.RENAVAM} onChange={handleChange} maxLength={11} />
                            </Form.Group>
                        </Col>

                        <Col md={2}>
                            <Form.Group controlId="cint">
                                <Form.Label>Cód. Veículo</Form.Label>
                                <Form.Control name="cint" type="text"
                                    value={form.cint} onKeyUp={handleNumberOnly} maxLength={10}
                                    onChange={handleChange} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group controlId="tpCar">
                                <Form.Label>Tipo Carroceria</Form.Label>
                                <Form.Select name="tpCar" value={form.tpCar} onChange={handleChange}>
                                    {TypeCarroceriaVeiculo.map(x => (
                                        <option key={x.id} value={x.id}>{x.name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="g-2 mb-3">

                        <Col md>
                            <Form.Group controlId="tpRod">
                                <Form.Label>Tipo Rodado</Form.Label>
                                <Form.Select name="tpRod" onChange={handleChange} value={form.tpRod}>
                                    {TypeRodadoVeiculo.map(x => (
                                        <option key={x.id} value={x.id}>{x.name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md>
                            <Form.Group controlId="capKG">
                                <Form.Label>Capacidade(kg)</Form.Label>
                                <Form.Control name="capKG" type="text" onKeyUp={handleNumberOnly} maxLength={6}
                                    value={form.capKG} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md>
                            <Form.Group controlId="capM3">
                                <Form.Label>Capacidade(M³)</Form.Label>
                                <Form.Control name="capM3" type="text" onKeyUp={handleNumberOnly}
                                    value={form.capM3} onChange={handleChange} maxLength={3} />
                            </Form.Group>
                        </Col>


                    </Row>
                    <Row className="mb-3">
                        <Col md>
                            <Form.Group controlId="codAgPorto">
                                <Form.Label>Cod. Ag. Porto</Form.Label>
                                <Form.Control name="codAgPorto" type="text"
                                    value={form.codAgPorto} onChange={handleChange} maxLength={16} />
                            </Form.Group>
                        </Col>
                        <Col md={'auto'}>
                            <Form.Group controlId="uf">
                                <Form.Label>UF</Form.Label>
                                <Form.Select name="uf" onChange={handleChange}
                                    className={`${errors.modal_rodoviario_tracao_uf?.length > 0 ? "is-invalid" : ""}`}
                                    value={form.uf}>
                                    {selectEstados?.map((estado: any) => {
                                        return <option
                                            key={estado.id} value={estado.uf}>{estado.uf === "" ? estado.name : estado.uf}
                                        </option>
                                    })}
                                </Form.Select>
                                <MakeMessageError errors={errors} field="modal_rodoviario_tracao_uf" />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="g-2 mb-2">
                        <Col md >
                            <Form.Group >
                                <Form.Switch type="switch" onChange={handleChangeShowProp}
                                    checked={showProp || Object.keys(form.prop).length > 0}
                                    name="active" label="O proprietário não é emitente iniciado no aplicativo?" />
                            </Form.Group>
                        </Col>

                    </Row>
                    {(showProp || Object.keys(form.prop).length > 0) && (
                        <>
                            <Row className="g-2 mb-3">
                                <Col md>
                                    <Form.Group controlId="rntrc">
                                        <Form.Label>* RNTRC</Form.Label>
                                        <Form.Control type="text" name="rntrc" onChange={handleChangeProp}
                                            value={formProp.rntrc} maxLength={8} />
                                        <MakeMessageError errors={errors} field="modal_rodoviario_tracao_prop_rntrc" />
                                    </Form.Group>
                                </Col>

                                <Col md>
                                    <Form.Group controlId="tpProp">
                                        <Form.Label>Tipo Proprietário</Form.Label>
                                        <Form.Select name="tpProp" value={formProp.tpProp} onChange={handleChangeProp}>
                                            {TypeProprietarioVeiculo.map(x => (
                                                <option key={x.id} value={x.id}>{x.name}</option>
                                            ))}
                                        </Form.Select>
                                        <MakeMessageError errors={errors} field="modal_rodoviario_tracao_prop_tpProp" />
                                    </Form.Group>
                                </Col>

                                <Col md={'auto'}>
                                    <Form.Group controlId="uf-prop">
                                        <Form.Label>UF</Form.Label>
                                        <Form.Select name="uf" value={formProp.uf} onChange={handleChangeProp}>
                                            {selectEstados?.map((estado: any) => {
                                                return <option key={estado.id} value={estado.uf}>
                                                    {estado.uf === "" ? estado.name : estado.uf}
                                                </option>
                                            })}

                                        </Form.Select>
                                        <MakeMessageError errors={errors} field="modal_rodoviario_tracao_prop_uf" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="g-2 mb-2">
                                <Col md>
                                    <Form.Group controlId="xNome">
                                        <Form.Label>* Nome do proprietário</Form.Label>
                                        <Form.Control type="text" name="xNome" value={formProp.xNome} maxLength={60}
                                            onChange={handleChangeProp} />
                                        <MakeMessageError errors={errors} field="modal_rodoviario_tracao_prop_xNome" />
                                    </Form.Group>
                                </Col>

                                <Col md={'3'}>
                                    <Form.Group controlId="cpfcnpj">
                                        <Form.Label>* CPF/CNPJ</Form.Label>
                                        <Form.Control type="text" name="cpfcnpj" value={formProp.cpfcnpj}
                                            onKeyUp={handleNumberOnly} onChange={handleChangeProp} maxLength={14} />
                                        <MakeMessageError errors={errors} field="modal_rodoviario_tracao_prop_cpfcnpj" />
                                    </Form.Group>
                                </Col>

                                <Col md={'3'}>
                                    <Form.Group controlId="ie">
                                        <Form.Label>Inscrição Estadual</Form.Label>
                                        <Form.Control type="text" name="ie" value={formProp.ie} maxLength={14}
                                            onKeyUp={handleNumberOnly} onChange={handleChangeProp} />
                                        <MakeMessageError errors={errors} field="modal_rodoviario_tracao_prop_ie" />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>

                    )}
                </CardBody>
            </Card>



        </Col>
    </Row>)
}